<div class="loading w-4 {{customClass}}" [style]="customStyle">
</div>
